// Tags where no backend solution exists.
// For these, we skip calling the contact details API to prevent 404 errors.

const tagsWithNoSolution = [
  "/returns | exchangingAnItem | other",
  "/returns | exchangingAnItem | exchanges",
  "/returns | exchangingAnItem | faultyLarge",
];

export const hasNoSolution = (location = "") => {
  return tagsWithNoSolution.includes(location);
};
